<script setup lang="ts">
    import { defineAsyncComponent } from 'vue';
    import TopBannerLeft from '../components/oferta/TopBannerLeft.vue' 
    import FormarBloque from '../components/oferta/FormarBloqueNeo.vue';
    const MtrPlanEstudios = defineAsyncComponent(() => import('../components/oferta/MtrPlanEstudios.vue')) ; 
    const VerModelo = defineAsyncComponent(() => import('../components/oferta/VerModelo.vue')) 
    // const VerModelo = defineAsyncComponent(() => import('../components/oferta/VerModeloTiny.vue')) 
    // const MtrModEjec = defineAsyncComponent(() => import('../components/oferta/MtrModEjec.vue')) ;
    const PoliticaIA = defineAsyncComponent(() => import('../components/oferta/PoliticaIA.vue'))
    const CalendarioOferta = defineAsyncComponent(() => import('../components/oferta/CalendarioOferta.vue'))  
</script>

<template>
    <TopBannerLeft
        :img="'background-image: url(../../pagesImages/banner-alta1.jpg);'"
        :nivel="'Maestr&iacute;a en'"
        :carrera="'Alta Direcci&oacute;n'"
        :complemento="'Corporativa'"
        :frase="'Reunirse es un comienzo. Mantenerse juntos es un progreso. Trabajar juntos es el &eacute;xito'"
        :autor="'Henry Ford'"
    />

    <FormarBloque
        :img="'../../pagesImages/estudiante-maestria-alta-direccion-corporativa-objetivos.webp'"
        :link="'/requisitos-maestria'"
        :frase="'Desarrolla habilidades directivas clave; estrategia, liderazgo y gestión financiera para liderar organizaciones en entornos complejos'"
        :testo1="'La Maestría en Alta Dirección Corporativa en Universidad Humanitas está diseñada para  potenciar las habilidades directivas y estratégicas, ofreciéndole al profesional, una visión global de la organización y sus desafíos.<br><br>Con un enfoque en la toma de decisiones, liderazgo y crecimiento empresarial, esta maestría es necesaria para enfrentar los retos financieros y las variables microeconómicas con eficiencia y rapidez.'"
        :testo3="'Dirigida a directores, gerentes, empresarios y profesionales que ocupan o aspiran a ocupar puestos de alto nivel en empresas y organizaciones. Es ideal para quienes buscan fortalecer su liderazgo, mejorar sus habilidades estratégicas y adquirir una visión integral de la gestión empresarial.'"
        :alt="'Estudiante de Maestría en Alta Dirección Corporativa'"
    />

    <div class="flex items-center justify-center my-10">
    </div>

    <MtrPlanEstudios
        :ejecutivo="true"
        :virtual="true"
    />

    

    <VerModelo esco=""
    ejec="/pagesImages/Programas/Maestria/Plan_De_Estudios_Alta_Direccion_Web.webp,/pagesImages/Programas/Maestria/Plan_De_Estudios_Alta-Direccion_Pagina_Cel.webp"
    virt="/pagesImages/Programas/Maestria/Plan_De_Estudios_Alta_Direccion_Web.webp,/pagesImages/Programas/Maestria/Plan_De_Estudios_Alta-Direccion_Pagina_Cel.webp"
    :escoT="false"
    :ejecT="true"
    :virtT="true" />
    <!-- <VerModelo esco=""
    ejec="/pagesImages/Programas/Maestria-ant/maestria-alta-direccion-ejecutivo.webp"
    virt="/pagesImages/Programas/Maestria-ant/maestria-alta-direccion-ejecutivo.webp"
    :escoT="false"
    :ejecT="true"
    :virtT="true" /> -->

    <CalendarioOferta nombre="Maestría en Alta Dirección" 
  :inicios="[true, false, true, false, true, false, true, false]"></CalendarioOferta>

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-4 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block font-serif text-[42px] text-hgold text-left" style="">Estructura académica</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-xl text-left mb-3">(Bloques trimestrales):</span>
                        </h2>
                        <ul class="list-disc pl-5 mb-4">
                            <li><b>Bloque administrativo:</b> Desarrollo de habilidades en planeación, organización y control empresarial.</li>
                            <li><b>Bloque de Recursos Humanos:</b> Estrategias de gestión del talento, liderazgo y cultura organizacional.</li>
                            <li><b>Bloque corporativo:</b> Gobernanza empresarial, normativas y estructura organizacional.</li>
                            <li><b>Bloque financiero:</b> Análisis financiero, gestión de inversiones y toma de decisiones económicas.</li>
                            <li><b>Bloque comercial:</b> Estrategias de ventas, marketing y expansión de negocios.</li>
                            <li><b>Seminario de titulación:</b> Desarrollo de un proyecto aplicado para la obtención del grado.</li>
                            <!-- <li><b>Seminario de Inteligencia Artificial.</b> Conocimiento, comprensión y aplicación de las herramientas de Inteligencia Artificial en entornos académicos, profesionales y laborales, fortaleciendo las habilidades y capacidades.</li> -->
                        </ul>
                        <p>
                            Este programa ofrece un enfoque práctico y estratégico para formar líderes empresariales altamente capacitados, capaces de impulsar el crecimiento y la competitividad en sus organizaciones.
                        </p>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/hombre-mujer-maestria-estructura.webp" alt="Alt pendiente" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>

    <!-- <MtrModEjec class="mb-16" />

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col px-4 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">Metodología</span>
                        </h2>
                        <p class="mb-4">
                            El modelo ejecutivo se desarrolla bajo la siguiente estructura:
                        </p>
                        <ul class="list-disc pl-5 mb-4">
                            <li>Consta de 6 bloques trimestrales.</li>
                            <li>Cada bloque equivale a tres materias fusionadas, impartidas por un especialista en la materia.</li>
                            <li>Se imparten clases un día a la semana, tres horas de clases presenciales.</li>
                            <li>El modelo educativo tiene una duración de diez semanas de clases, y una semana adicional culminando con una evaluación final.</li>
                            <li>La evaluación se compone de participación en clase, foros, trabajos y examen final, integrando así un proceso de aprendizaje integral.</li>
                        </ul>
                        <p>
                            Este modelo permite a los estudiantes desarrollar habilidades especializadas con un enfoque práctico y estratégico, alineado con las exigencias del mundo profesional actual.
                        </p>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/universidad-fisica-virtual.webp" alt="Estudiantes de maestría en alta dirección corporativa universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section> -->
    
    <section class="lg:flex items-center justify-center bg-cover bg-[center] bg-no-repeat mb-16" style="background-image: url(/pagesImages/madin3.jpg); position: relative; background-attachment: fixed; background-position: left; background-repeat: no-repeat; background-size: cover; overflow: hidden; transition: transform 0.3s ease;">
        <div class="lg:flex items-center justify-center w-full h-full my-16">
            <div class="lg:flex items-center justify-between w-full max-w-[1200px]">
                <img src="/pagesImages/perfil-egresado-maestrias.webp" alt="Hoy egresas como un profesional preparado para enfrentar los retos del futuro" class="lg:p-0 w-full lg:max-w-[520px] md:px-16 px-6 pt-6"/>
                <div class="flex flex-col lg:justify-start justify-center items-center lg:items-start lg:w-[50%] w-full lg:my-24 py-12 text-justify lg:px-0  px-8">
                    <h2>
                        <span class="block text-[28px] text-hwine leading-none text-center md:text-left">Perfil del egresado de la maestría en</span>
                        <span class="sr-only whitespace-nowrap">&nbsp;</span>
                        <span class="block text-hwine text-[42px] mb-4 leading-tight text-center md:text-left font-serif ">Alta Dirección Corporativa</span>
                    </h2>
                    <p class="text-justify text-gray-800 lg:hyphens-manual hyphens-auto">Son profesionales con experiencia en la toma de decisiones estratégicas, gestión de recursos y liderazgo organizacional. Se busca que desarrollen competencias clave en dirección general, administración corporativa y manejo de retos financieros y comerciales, con un enfoque global y práctico.</p>
                    <br>
                    <router-link to="/contacto">
                        <div class="flex items-center justify-center w-[140px] h-[35px] hover:bg-hwine bg-hgold text-white  text-lg transition duration-300 ease-in-out">
                            <span>Inscr&iacute;bete</span>
                        </div>
                    </router-link>
                </div>
            </div>
        </div>
    </section>

    <section class="flex items-center justify-center mb-16 w-full">
		<div class="lg:flex flex-col lg:px-4 px-8 items-center w-full max-w-4xl lg:max-w-[1200px] justify-start">
			<div class="flex flex-col justify-between w-full">
				<div class="lg:flex items-center justify-center">
                    <div class="lg:w-[50%] text-justify mb-8 lg:mb-0 lg:mr-12">
                        <h2>
                            <span class="block leading-none text-left text-[28px]" style="">Cinco razones para elegir</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hgold text-left font-serif mb-3 text-[42px]">Universidad Humanitas:</span>
                        </h2>
                        <ul class="list-disc pl-5 mb-4">
                            <li>Modelo educativo especializado.</li>
                            <li>Excelencia académica.</li>
                            <li>Instalaciones de primer nivel.</li>
                            <li>Costos accesibles.</li>
                            <li>Acreditaciones reconocidas (SEP, ESR y GPTW).</li>
                        </ul>
                    </div>
                    <div class="flex items-center justify-center w-full lg:max-w-[520px]">
						<img src="/pagesImages/beneficios-estudiar-universidad-humanitas.webp" alt="Beneficios de estudiar en Universidad Humanitas" class="w-full lg:max-w-[520px]"/>
					</div>
                </div>
			</div>
		</div>
	</section>
    <PoliticaIA />
</template>

<style scoped>
</style>